import axios from 'axios';
import {APP_CONFIG} from '@app_config/app';

console.log('process.env',process.env);
console.log('APP_CONFIG', APP_CONFIG);

// interfaces
export interface ResponseT<T> {
  errors: string[];
  limit?: number;
  total?: number;
  size?: number;
  start_after?: number;
  continues?: boolean;
  data?: T;
}

/* Set up the apiClient endpoints set depending on environment parameter REACT_APP_HOST_TYPE */
export const apiClient_local = axios.create({
  baseURL: 'https://localhost:8000/cmp',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const apiClient_sciscore_local = axios.create({
  baseURL: 'https://localhost:61361/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const apiClient_dev = axios.create({
  baseURL: 'https://compoundservice.thewarriors3.com/cmp', // <- ENV variable
  //baseURL: 'http://localhost:8000/cmp', // <- ENV variable
  headers: {
    'Content-Type': 'application/json',
  },
});

export const apiClient_sciscore_dev = axios.create({
  baseURL: 'https://sciscore-api-dev.thewarriors3.com/api', // <- ENV variable
  //baseURL: 'https://localhost:61361/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const apiClient_prd = axios.create({
  // rollback
  baseURL: 'https://compoundservice-prd.thewarriors3.com/cmp', // <- ENV variable
  headers: {
    'Content-Type': 'application/json',
  },
});

export const apiClient_sciscore_prd = axios.create({
  // rollback
  baseURL: 'https://api.sciscore.asedasciences.com/api', // <- ENV variable
  headers: {
    'Content-Type': 'application/json',
  },
});

// using the REACT_APP_HOST_TYPE that is set in package json scripts

export const apiClient =
  process.env.REACT_APP_HOST_TYPE === 'prd'
    ? apiClient_prd
    : process.env.REACT_APP_HOST_TYPE === 'local'
    ? apiClient_local
    : apiClient_dev;

export const apiSciScoreClient =
  process.env.REACT_APP_HOST_TYPE === 'prd'
    ? apiClient_sciscore_prd
    : process.env.REACT_APP_HOST_TYPE === 'local'
    ? apiClient_sciscore_local
    : apiClient_sciscore_dev;

export const authClient = (token) => {
  apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  return apiClient;
};

/* Set up the apiCoreClient endpoints set depending on environment parameter REACT_APP_HOST_TYPE */
export const apiCoreClient_local = axios.create({
  baseURL: 'http://localhost:8000/',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const apiCoreClient_dev = axios.create({
  baseURL: 'https://core-api.thewarriors3.com/', // <- ENV variable
  headers: {
    'Content-Type': 'application/json',
  },
});

export const apiCoreClient_prd = axios.create({
  // rollback
  baseURL: 'https://core-api.asedasciences.com/', // <- ENV variable
  headers: {
    'Content-Type': 'application/json',
  },
});

export const authSciScoreClient = (token) => {
  apiSciScoreClient.defaults.headers.common[
    'Authorization'
  ] = `Bearer ${token}`;
  return apiSciScoreClient;
};

export const apiCoreClient =
  process.env.REACT_APP_HOST_TYPE === 'prd'
    ? apiCoreClient_prd
    : process.env.REACT_APP_HOST_TYPE === 'local-core'
    ? apiCoreClient_local
    : apiCoreClient_dev;

export const authCoreClient = (token) => {
  apiCoreClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  return apiCoreClient;
};
